import templateUrl from './team-leader-dashboard.component.html'
import { EmployeeService, RoleService } from '../../core/services';
import { UtilityService } from '../../core/services/utility.service';

export const TeamLeaderDashboardComponent = {
    controller: TeamLeaderDashboardController,
    controllerAs: "vm",
    templateUrl
}


function TeamLeaderDashboardController($q, employeeService: EmployeeService, roleService: RoleService,
    teamService, utilityService: UtilityService) {
    'ngInject'
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this;

    vm.$onInit = onInit;
    vm.onAddTeamMember = onAddTeamMember;
    vm.onAssignTeamMemberRoles = onAssignTeamMemberRoles;
    vm.onChangeEmailAddress = onChangeEmailAddress;
    vm.onRemoveTeamMember = onRemoveTeamMember;
    vm.onSaveNewTeamMember = onSaveNewTeamMember;
    vm.onSaveEditedTeamMember = onSaveEditedTeamMember;
    vm.team; // The selected team.
    vm.teams;
    vm.teamLeaderID;

    function onInit() {
        const identity = employeeService.retrieveIdentity();
        const teamsLoaded = identity.then(identity => teamService.retrieveTeams({
            TeamLeaderIDs: [identity.EmployeeID]
        }));

        teamsLoaded.then(function (teams) {
            vm.teams = teams;
            vm.selectedTeam = teams.length === 1 ? teams[0] : null;
        }).then(loadSelectedTeam);
    }

    /**
     * Display a modal that allows a new team member to be added to the given team.
     * @param {any} team
     */
    function onAddTeamMember(team) {
        vm.editedTeamMember = null; // Close edit form in case it's open.
        vm.newTeamMember = {
            accountMode: 'newAccount',
            Roles: team.Roles.map(function (role) {
                return {
                    Id: role.Id,
                    Name: role.Name,
                    Description: role.Description,
                    IsInRole: true
                };
            })
        };
    }

    function onAssignTeamMemberRoles(team, teamMember) {
        vm.newTeamMember = null; // Close the new team member form, in case it's open.

        // Get currently assigned roles for the employee from the roles list.
        const employeeLoaded = employeeService.retrieveEmployee(teamMember.EmployeeID)
            .then(function (employee) {
                const roles = team.Roles.map(function (role) {
                    const isInRole = employee.GlobalRoles[role.Id];
                    return {
                        Id: role.Id,
                        Name: role.Name,
                        Description: role.Description,
                        IsInRole: isInRole
                    };
                });
                teamMember.Roles = roles;
                vm.editedTeamMember = {
                    EmployeeID: teamMember.EmployeeID,
                    Employee: teamMember.Employee,
                    Roles: roles,
                    Leader: teamMember.Leader
                };
            });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(employeeLoaded, "Loading roles failed"));
    }

    function loadSelectedTeam() {
        if (vm.selectedTeam && vm.selectedTeam.TeamID) {
            return teamService.retrieveTeam(vm.selectedTeam.TeamID)
                .then(function (team) {
                    const employeesLoaded = loadTeamEmployees(team);
                    const rolesLoaded = loadTeamRoles(team);
                    team.employeeSelectOptions = createTeamMemberSelectOptions(team);
                    return $q.all([employeesLoaded, rolesLoaded])
                        .then(function () {
                            // Wait until data is loaded before resolving the team in the view model.
                            vm.team = team;
                            return team;
                        });
                });
        }
        // Otherwise, clear the selected team.
        vm.team = null;
        return $q.when();
    }

    function onSaveNewTeamMember(team, teamMember) {
        // Add the given team member to the team.
        if (vm.newTeamMemberForm && vm.newTeamMemberForm.$invalid) {
            alert("Validation errors were found. Please address any errors and try again.");
        }
        const request: any = {};
        request.TeamID = team.TeamID;
        if (teamMember.accountMode === "existing") {
            request.EmployeeID = teamMember.Employee.EmployeeID;
        } else {
            request.FirstName = teamMember.FirstName;
            request.LastName = teamMember.LastName;
            request.EmailAddress = teamMember.EmailAddress;
            request.Password = teamMember.Password;
        }
        request.Leader = teamMember.Leader || false;
        request.Roles = teamMember.Roles.reduce(function (roles, role) {
            roles[role.Id] = role.IsInRole;
            return roles;
        }, {});

        // Assign this now before the teamMember goes out of scope.
        const employee: any = {};
        if (teamMember.accountMode === "newAccount") {
            employee.FirstName = request.FirstName;
            employee.LastName = request.LastName;
            employee.EmailAddress = request.EmailAddress;
        } else {
            employee.Id = request.EmployeeID;
            employee.FirstName = teamMember.Employee.FirstName;
            employee.LastName = teamMember.Employee.LastName;
            employee.EmailAddress = teamMember.Employee.EmailAddress;
        }

        const saved = teamService.addTeamMember(team.TeamID, request)
            .then(function (employeeID) {
                employee.Id = employeeID;
                employee.Roles = request.Roles;
                const teamMember = {
                    EmployeeID: employee.Id,
                    Employee: employee,
                    Leader: request.Leader
                };
                team.TeamMembers.push(teamMember);
                vm.newTeamMember = null;
            });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(saved, "Save failed"));
    }

    function onSaveEditedTeamMember(team, teamMember) {
        // Add the given team member to the team.
        if (vm.editedTeamMemberForm && vm.editedTeamMemberForm.$invalid) {
            alert("Validation errors were found. Please address any errors and try again.");
        }
        const employeeID = teamMember.EmployeeID;
        const request: any = {};
        request.Leader = teamMember.Leader;
        request.Roles = teamMember.Roles.reduce(function (roles, role) {
            roles[role.Id] = role.IsInRole;
            return roles;
        }, {});
        const teamMembers = team.TeamMembers;

        const saved = teamService.assignTeamMemberRoles(team.TeamID, employeeID, request.Roles, request.Leader)
            .then(function () {
                const teamMember = teamMembers.filter(function (teamMember) {
                    return teamMember.EmployeeID === employeeID;
                })[0];
                teamMember.Roles = request.Roles;
                teamMember.Leader = request.Leader;
                vm.editedTeamMember = null;
            });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(saved, "Save failed"));
    }

    function onRemoveTeamMember(team, teamMember) {
        if (!confirm("Are you sure?")) {
            return;
        }
        const removed = teamService.removeTeamMember(team.TeamID, teamMember.EmployeeID)
        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(removed, "Remove failed"));

        removed.then(function () {
            // Delete from the list after removal has gone through.
            team.TeamMembers = team.TeamMembers.filter(function (_teamMember) {
                return teamMember.EmployeeID !== _teamMember.EmployeeID;
            });
        })
    }

    function onChangeEmailAddress(id) {
        if (!vm.newTeamMemberForm || !vm.newTeamMemberForm["EmailAddress_" + id]) {
            return;
        }

        vm.newTeamMember.availableEmailAddress = false;

        const notOnTeam = $q.when(!vm.team.TeamMembers.reduce(function (any, teamMember) {
            return any || utilityService.equalsInvariant(teamMember.Employee.EmailAddress,
                vm.newTeamMember.EmailAddress);
        }, false));
        const unique = employeeService.isEmailAddressAvailable(vm.newTeamMember.EmailAddress);

        $q.all([notOnTeam, unique])
            .then(function (v) {
                const notOnTeam = v[0];
                const unique = v[1];

                vm.newTeamMember.availableEmailAddress = unique;

                // Uniqueness is fine if the email is already used by a user on the team, but fail validation for a different reason.
                vm.newTeamMemberForm["EmailAddress_" + id].$setValidity("unique", !notOnTeam || unique);
                vm.newTeamMemberForm["EmailAddress_" + id].$setValidity("not-on-team", notOnTeam);
            });

    }

    function loadTeamEmployees(team) {
        const employeesIDs = team.TeamMembers.map(function (teamMember) {
            return teamMember.EmployeeID;
        });
        return employeeService.retrieveEmployees({
            EmployeeIDs: employeesIDs
        }).then(function (employees) {
            team.TeamMembers.forEach(function (teamMember) {
                teamMember.Employee = employees.filter(function (employee) {
                    return employee.Id === teamMember.EmployeeID;
                })[0];
            });

            team.TeamMembers.sort(sortTeamMembers)
        });
    }

    function loadTeamRoles(team) {
        return roleService.retrieveRoles()
            .then(function (roles) {
                team.Roles = team.Roles.map(function (roleID) {
                    return roles.filter(function (role) {
                        return role.Id === roleID;
                    })[0];
                });
            });
    }

    /**
     * Create options for a team member multi-select based on the current team.
     */
    function createTeamMemberSelectOptions(team) {
        const dataSource = {
            transport: {
                read: function (options) {
                    // Load both selected team members and the first page of search results based on the filter.
                    const filters: any = {};
                    if (options.data.filter && options.data.filter.filters) {
                        if (options.data.filter.filters[0]) {
                            filters.FullName = options.data.filter.filters[0].value;
                        }
                    }

                    const globalRoleIDs = team.Roles.map(function (role) {
                        return role.Id;
                    });

                    const searchResults = employeeService.retrieveEmployees({
                        FullName: filters.FullName,
                        PageIndex: options.data.pageIndex,
                        PageSize: options.data.pageSize,
                        IsGlobal: !vm.team.IcdCorporationID,
                        GlobalRoleIDs: globalRoleIDs
                    }).then(function (employees) {
                        return employees.map(function (employee) {
                            return {
                                EmployeeID: employee.Id,
                                FirstName: employee.FirstName,
                                LastName: employee.LastName,
                                EmailAddress: employee.EmailAddress,
                                FullName: (employee.FirstName || "") + " " + (employee.LastName || ""),
                                Leader: false
                            };
                        });
                    });
                    searchResults
                        .then(function (searchResults) {
                            return searchResults.filter(function (employee) {
                                // Existing team members should be excluded from this list.
                                return !team.TeamMembers.reduce(function (any, teamMember) {
                                    return any || teamMember.EmployeeID === employee.EmployeeID;
                                }, false);
                            });
                        })
                        .then(function (employees) {
                            options.success(employees);
                        })
                        .catch(function (ex) {
                            options.error(ex);
                        });
                }
            },
            serverFiltering: true,
            serverPaging: true,
            pageSize: 30
        };
        return {
            dataSource: dataSource,
            dataTextField: "FullName",
            optionLabel: { FullName: "Select" },
            filter: "contains",
            autoClose: false
        }
    }

    function sortTeamMembers(a, b) {
        if (a.Leader && !b.Leader) {
            return -1;
        } else if (!a.Leader && b.Leader) {
            return 1;
        } else if (a.Employee.FirstName < b.Employee.FirstName) {
            return -1;
        } else if (a.Employee.FirstName > b.Employee.FirstName) {
            return 1;
        } else if (a.Employee.LastName < b.Employee.LastName) {
            return -1;
        }
        return 1;
    }
}
